(function($) {

  function facebookCheckLoginStatus() {               // Called when a person is finished with the Login Button.
    popupLoading();
    FB.getLoginStatus(facebookGetLoginStatusCallback);
  }

  function facebookGetLoginStatusCallback(response) {  // Called with the results from FB.getLoginStatus().
    if (response.status === 'connected') {
      facebookGetUserData();
    } else {
      FB.login(facebookLoginCallback, {scope: 'public_profile,email'});
    }
  }

  function facebookLoginCallback(response) {
    if (response.status === 'connected') {
      facebookGetUserData( response );
    } else {
      // The person is not logged into your webpage or we are unable to tell.
      popupClose();
    }
  }


  function facebookGetUserData() {
    FB.api('/me','GET', {"fields":"first_name,last_name,name,email"}, function (response) {
      if ( response.email ) {
        $.ajax({
          data: {
            action: 'bs_facebook_login',
            user: response,
          }
        });
      } else {
        FB.login(facebookLoginCallback, {scope: 'public_profile,email'});
      }
    });
  }

  $(document).on('click', '.doFacebookLogin', facebookCheckLoginStatus);

})(jQuery)